import React from 'react';
import { Toolbar } from '@mui/material';
import { Outlet } from 'react-router-dom';

import { Box, Flex } from '../../Components/Base';
import { AppBar, MENU_DRAWER_WIDTH, APP_BAR_HEIGHT } from '../../Components/Layout';
import UserButton from '../UserButton';
import SideBar from '../SideBar';
import HamburgerMenu from '../HamburgerMenu';

import Header from './Header';
import ExaminationEventManagement from './ExaminationEventManagement';
import ExaminationEventProvider from './ExaminationEventProvider';

const ExaminationEventLayout = ({ children }: { children?: React.ReactChild }) => {
  return (
    <ExaminationEventProvider>
      <AppBar>
        <HamburgerMenu />
        <Flex width={1} justifyContent={'space-between'}>
          <Header />
          <UserButton />
          {/* TODO: Info icon */}
        </Flex>
      </AppBar>
      <SideBar />
      <Toolbar />
      <Flex bgcolor={'grey.50'}>
        <Box width={`${MENU_DRAWER_WIDTH}px`} display={{ xs: 'none', md: 'block' }} />
        <Flex
          flexDirection={'column'}
          component="main"
          p={3}
          minHeight={`calc(100vh - ${APP_BAR_HEIGHT}px)`}
          width={{ md: `calc(100% - ${MENU_DRAWER_WIDTH}px)` }}
          maxWidth={1440}
          m={'auto'}
          sx={{ flexGrow: 1 }}
        >
          <ExaminationEventManagement />
          <Box mt={2} />
          {children ?? <Outlet />}
        </Flex>
      </Flex>
    </ExaminationEventProvider>
  );
};

export default ExaminationEventLayout;
